import React from 'react';
import styled, { css } from 'styled-components';
import { breakpointMap, BreakpointsOfTOrT, theme } from '../../../theme';

export type BodySize = 'xxs' | 'xs' | 'sm' | 'md' | 'lg';

type BaseBodyTextProps = React.HTMLAttributes<HTMLParagraphElement>;

export type StyledBodyTextProps = {
  size: BreakpointsOfTOrT<BodySize>;
  color?: string;
};

type CombinedBodyTextProps = BaseBodyTextProps & StyledBodyTextProps;

export const BaseBodyTextStyles = css<StyledBodyTextProps>`
  color: ${({ color }) => (color ? color : theme.colors.primary.graysGray)};
  padding: 0;
  margin: 0;

  ${({ size }) =>
    breakpointMap(size, (bodySize) => theme.typography.body[bodySize])};
`;

const BaseBodyText = styled.p<CombinedBodyTextProps>`
  ${BaseBodyTextStyles};
`;

export type BodyTextProps = Partial<CombinedBodyTextProps>;

export const BodyText: React.FC<BodyTextProps> = ({
  children,
  size = 'md',
  ...props
}) => {
  return (
    <BaseBodyText size={size} {...props}>
      {children}
    </BaseBodyText>
  );
};
